import axios from 'axios';

import {RolePermission, UserPermissions, UserRole} from 'types';

import {API_URL} from './constants';

const getUserPermissions = async (): Promise<UserPermissions> => {
    const response = await axios.post(`${API_URL}/auth/permissions/me`);
    return response?.data;
};

const getRoles = async (): Promise<UserRole[]> => {
    const response = await axios.post(`${API_URL}/auth/roles/list`);
    return response?.data;
};

const getRolesPermissions = async (): Promise<RolePermission[]> => {
    const response = await axios.post(`${API_URL}/auth/roles/permissions`);
    return response?.data;
};

const getAvailablePermissions = async (): Promise<UserPermissions> => {
    const response = await axios.post(`${API_URL}/auth/permissions/available`);
    return response?.data;
};

const updateRole = async (role: RolePermission) => {
    const response = await axios.put(`${API_URL}/auth/roles`, role);
    return response?.data;
};

const createRole = async ({name, permissions}) => {
    const response = await axios.post(`${API_URL}/auth/roles`, {name, permissions});
    return response?.data;
};

const removeRole = async (id: string) => {
    const response = await axios.delete(`${API_URL}/auth/roles/${id}`);
    return response?.data;
};

export const rolesApi = {
    createRole,
    updateRole,
    removeRole,
    getUserPermissions,
    getRoles,
    getRolesPermissions,
    getAvailablePermissions
};